import { CalculatorType, Scenario } from 'spw-redux/modules/calculators/types';
import _ from 'lodash';
import { GROWTH_CALCULATORS } from 'spw-constants';
import ProgramScenario, { PlainProgramScenario } from './Scenario';
import ProgramScenarioFactory from './ProgramScenarioFactory';

export default class MacroScenario extends ProgramScenario {
  constructor(apiScenario: Scenario) {
    super(apiScenario.base, apiScenario);
    this.primaryLabel = 'Macro Program';
  }

  static parseFromAnotherCalculatorType = (scenario: PlainProgramScenario) => {
    const newScenario = _.cloneDeep(scenario);

    newScenario.startYear = new Date().getFullYear();
    newScenario.department = null;
    newScenario.floorId = null;
    newScenario.headcountSeatCountGrowthRate = null;
    newScenario.headcountSeatCountBase = null;
    newScenario.targetYear = null;
    newScenario.vacancyFactorPercentage = 0;
    newScenario.headcount = Math.round(newScenario.headcountWithVacancy);
    newScenario.calculatorType = GROWTH_CALCULATORS.macroProgramming as CalculatorType;

    return ProgramScenarioFactory.create(
      ProgramScenario.toAPIScenario(newScenario)
    );
  };
}
